export default {
  'customer.publicCustomer': '公共池客户',
  'customer.operation.modal.chooseStaff': '请选择员工',
  'customer.addCustomer': '添加客户',
};
